import { BaseForm, FormContent } from 'app/pages/Registration/interfaces';

export const pathFromString = (input: string): string =>
  input.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);

export type FormValues =
  | number
  | string
  | null
  | boolean
  | { period: string; plan: number | null };
const defaultValue = (types: FormContent['type']): FormValues => {
  switch (types) {
    case 'boolean':
      return false;
    case 'countrySelect':
      return null;
    case 'pricePlan':
      return { period: 'monthly', plan: null };
    case 'number':
      return 1;
    case 'email':
    case 'tel':
    case 'string':
    default:
      return '';
  }
};

export type IForm = Record<string, Record<string, FormValues>>;

export const generateInitialForm = (form: BaseForm[]): IForm =>
  form.reduce((acc, element) => {
    acc[element.path] = {};
    element.content.forEach((content) => {
      if (content.type !== 'pricePlan' && content.type !== 'confirm') {
        acc[element.path][content.label] = defaultValue(content.type);
      } else {
        acc[element.path].pricePlan = defaultValue(content.type);
      }
    });
    return acc;
  }, {} as Record<string, Record<string, FormValues>>);
